export default "__VITE_ASSET__D$U7XLUi__"